import { useMemo } from 'react'
import { computeRange } from '../utils/date'
import type { GanttChartProps, TimelineComputed, ViewMode } from '../types'

export const useTimeline = (
  props: Pick<
    GanttChartProps,
    'tasks' | 'view' | 'timezone' | 'startDate' | 'endDate' | 'columnWidth' | 'showWeekends'
  > & {
    defaultView?: ViewMode
    defaultColumnWidth?: number
  }
): TimelineComputed => {
  const {
    tasks,
    view,
    timezone,
    startDate,
    endDate,
    columnWidth,
    showWeekends,
    defaultView = 'month',
    defaultColumnWidth = 28,
  } = props

  return useMemo(
    () =>
      computeRange(
        tasks,
        (view || defaultView) as ViewMode,
        timezone || 'UTC',
        startDate,
        endDate,
        columnWidth ?? defaultColumnWidth,
        showWeekends ?? true
      ),
    [tasks, view, timezone, startDate, endDate, columnWidth, showWeekends, defaultView, defaultColumnWidth]
  )
}
